import { Routes } from "@angular/router";

export const homeRoutes: Routes = [
  {
    path: "",
    loadChildren: () => import("./domains/search/search.routes").then(r => r.searchRoutes),
  },
  {
    path: "swap-request-details",
    loadChildren: () => import("./domains/swap-request-details/swap-request-details.routes").then(r => r.swapRequestDetailsRoutes),
  },
];
